module.exports = __webpack_public_path__ + "static/media/img50.4df6e16c.jpg";